import * as Sentry from '@sentry/react';

function toSentryEnvironment(environment: string): string {
  const normalized = environment.trim().toLowerCase();

  if (normalized === 'dev' || normalized === 'development') return 'development';
  if (normalized === 'prod' || normalized === 'production') return 'production';

  return 'localhost';
}

export function initSentry(dsn: string, environment: string = 'LOCALHOST'): void {
  const sentryEnvironment = toSentryEnvironment(environment);

  Sentry.init({
    dsn,
    enabled: sentryEnvironment !== 'localhost',
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/.*petseo\.pl/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    environment: sentryEnvironment,
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'http' || breadcrumb.category === 'fetch') {
        if (breadcrumb.data) {
          Object.keys(breadcrumb.data).forEach((key) => {
            const lowerKey = key.toLowerCase();

            if (lowerKey === 'authorization' || lowerKey === 'st-auth-mode' || lowerKey === 'cookie') {
              breadcrumb.data![key] = '[Redacted]';
            }
          });
        }
      }
      return breadcrumb;
    },
  });
}
